module.exports = __webpack_public_path__ + "img/timeline_miscevent-1.5b9399dd.jpg";